import { Spinner } from "./spinner";

export function Splash() {
  return (
    <div className="flex w-screen h-screen items-center justify-center bg-white fixed top-0 left-0 z-50">
      <div className="flex flex-col gap-4 items-center justify-center">
        <img src="/media/logos/logo.svg" alt="logo" className="w-10 h-10" />
        <Spinner size={28} />
      </div>
    </div>
  );
}
